import React from 'react';
import classNames from 'clsx';

type BaseRowProps = {
    readonly className?: string;
    readonly children: React.ReactNode;
};

export const BaseCol = React.memo(({className, children}: BaseRowProps) => {
    return <div className={classNames('document-column', className)}>{children}</div>;
});
